import { Tag } from 'antd';
import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

interface IProps {
  status: boolean;
  owner: boolean;
}

export default function CompanyStatusTag({
  status,
  owner,
}: IProps): ReactElement {
  const { t } = useTranslation();

  if (owner) {
    return (
      <Tag color="blue">
        {t(
          'Company.List.Table.BelongsToThisEnv',
          'Belongs to this environment',
        )}
      </Tag>
    );
  }

  return (
    <Tag color={status ? 'green' : 'orange'}>
      {status
        ? t('Company.StatusTag.Approved', 'Approved')
        : t('Company.StatusTag.NotApproved', 'Not Approved')}
    </Tag>
  );
}
